import _ from 'underscore';
import React, { Component } from 'react';

import {
    Grid,
    Image,
    Segment,
    Header,
    Button,
    Message
} from 'semantic-ui-react';
import { confirmAlert } from 'react-confirm-alert'; // Import
import { Item } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import StpCardVisa from '../../../page/employee/stripe/img_stp_card_visa.png';
import StpCardAmex from '../../../page/employee/stripe/img_stp_card_amex.png';
import StpCardMasterCard from '../../../page/employee/stripe/img_stp_card_mastercard.png';
import StpCardDiscover from '../../../page/employee/stripe/img_stp_card_discover.png';
import StpCardJCB from '../../../page/employee/stripe/img_stp_card_jcb.png';
import StpCardDiners from '../../../page/employee/stripe/img_stp_card_diners.png';
import StpCardUnknown from '../../../page/employee/stripe/img_stp_card_unknown.png';
import {getCustomerAction, getEphemeralKeyAction, getProfileEphemeralKeyAction, deleteCardAction, setDefaultCardAction} from '../../../actions/stripeActions'
import {connect} from 'react-redux';
import moment from 'moment';
import AddCardPage from '../../../page/employee/add_card_page';

class ProfileWallet extends Component {
    componentWillMount() {
        // if(this.props.isnotificationOtp === 2 ){
            this.reload();
        // }
    }

    reload() {
        console.log("inside wallet")
        this.checkStripeSession((success) => {
            if (success) {
                if(this.props.stripe.ephemeralKey){
                    this.loadStripeCustomer()
                }
            }
        })
    }

    render() {
    var dataSource = this.props.stripe.customer ? this.props.stripe.customer.sources.data.filter((card) => card.object === 'card') : []
    return (
        <Grid>
            <Grid.Column width={16}>
                { this.props.stripe.error &&
                    <Message negative>
                        { this.props.stripe.error.message }
                    </Message> }
                <Grid columns={2}>
                    <Grid.Column>
                        <Header as='h4' attached='top' block>
                            Wallet Information
                        </Header>
                        {
                            _.map(dataSource, (rowData) => {
                                var isDefault = this.props.stripe.customer.default_source === rowData.id;
                                var imageSrc;
                                var cardName;
                                if (rowData.brand.toLowerCase() === "visa") {
                                    imageSrc = StpCardVisa
                                    cardName = "Visa";
                                } else if (rowData.brand.toLowerCase() === "american express") {
                                    imageSrc = StpCardAmex
                                    cardName = "Amex";
                                } else if (rowData.brand.toLowerCase() === "mastercard") {
                                    imageSrc = StpCardMasterCard
                                    cardName = "Mastercard";
                                } else if (rowData.brand.toLowerCase() === "discover") {
                                    imageSrc = StpCardDiscover
                                    cardName = "Discover";
                                } else if (rowData.brand.toLowerCase() === "jcb") {
                                    imageSrc = StpCardJCB
                                    cardName = "JCB";
                                } else if (rowData.brand.toLowerCase() === "diners club") {
                                    imageSrc = StpCardDiners
                                    cardName = "Diners Club";
                                } else {
                                    imageSrc = StpCardUnknown
                                    cardName = "Unknown";
                                }
                        
                                return (
                                    <Segment attached key={rowData.id}>
                                        <Item.Group divided>
                                            <Grid verticalAlign='middle' columns={4}>
                                                <Grid.Column width={2}>
                                                    <Image src={ imageSrc } />
                                                </Grid.Column>
                                                <Grid.Column width={7}>
                                                    {
                                                        isDefault 
                                                        ? <Header size='small'>{ cardName + ' ending in ' + rowData.last4 }</Header>
                                                        : <p>
                                                            { cardName + ' ending in ' + rowData.last4 }
                                                            </p>
                                                    }
                                                </Grid.Column>
                                                <Grid.Column width={4}>
                                                    { isDefault 
                                                        ? <Header size='small'>Default</Header>
                                                        : <Button 
                                                            loading={this.props.stripe.loading}
                                                            type="submit" 
                                                            primary 
                                                            disabled={this.props.stripe.loading}
                                                            fluid
                                                            size="small"
                                                            onClick={() => this._setDefaultCard(rowData.id)}
                                                            >
                                                            Set Default
                                                            </Button> }
                                                </Grid.Column>
                                                <Grid.Column width={3}>
                                                    <Button 
                                                        loading={this.props.stripe.loading}
                                                        type="submit" 
                                                        negative
                                                        disabled={this.props.stripe.loading}
                                                        fluid
                                                        size="small"
                                                        onClick={() => this._deleteCard(rowData.id, isDefault)}
                                                        >
                                                        Delete
                                                        </Button>
                                                </Grid.Column>
                                            </Grid>
                                        </Item.Group>
                                    </Segment>
                                );
                            })
                        }
                    </Grid.Column>
                    <Grid.Column>
                        <AddCardPage/>
                    </Grid.Column>
                </Grid>
            </Grid.Column>
        </Grid>
    );
    }


    _deleteCard(cardID, isDefault) {

        confirmAlert({
            title: 'Confirmation?',
            message: 'Are you sure you to delete this card?',
            buttons: [
            {
                label: 'Cancel',
                onClick: () => {}
            },
            {
                label: 'OK',
                onClick: () => {
                    this.checkStripeSession((success) => {
                        if (success) {
                            this.props.deleteCardAction(cardID).then(() => {
                                const {error} = this.props.stripe;
                                if (error) {
                                    // Alert.alert(
                                    //     error.title,
                                    //     error.message,
                                    //     [
                                    //         {
                                    //             text: 'OK'
                                    //         }
                                    //     ],
                                    //     {
                                    //         cancelable: false
                                    //     }
                                    // );
                                    return
                                }
                                if (isDefault) {
                                    this.reload()
                                }
                            })
                        }
                    })}
            }
            ]
        });
    }
    _setDefaultCard(cardID) {
        this.checkStripeSession((success) => {
            if (success) {
                this.props.setDefaultCardAction(cardID).then(() => {
                    const {error} = this.props.stripe;
                    if (error) {
                        // Alert.alert(
                        //     error.title,
                        //     error.message,
                        //     [
                        //         {
                        //             text: 'OK'
                        //         }
                        //     ],
                        //     {
                        //         cancelable: false
                        //     }
                        // );
                        return
                    }

                    // var openRight = this.state.openRight;
                    // this.props.stripe.customer.sources.data.map((card) => {
                    //     openRight[card.id] = false
                    // })
                    // this.setState({
                    //     openRight: openRight
                    // })

                })
            }
        })

    }

    checkStripeSession(successCallback) {
        if (this.props.stripe.ephemeral_key) {
            if (moment().unix() > this.props.stripe.ephemeral_key.expires) {
                this.props.getProfileEphemeralKeyAction().then(() => {
                    const {error} = this.props.stripe;
                    if (error) {
                        // Alert.alert(
                        //     error.title,
                        //     error.message,
                        //     [
                        //         {
                        //             text: 'OK'
                        //         }
                        //     ],
                        //     {
                        //         cancelable: false
                        //     }
                        // );
                        return successCallback(false);
                    }

                    return successCallback(true);

                })
            } else {
                return successCallback(true);
            }
        } else {
            this.props.getProfileEphemeralKeyAction().then(() => {
                const {error} = this.props.stripe;
                if (error) {
                    // Alert.alert(
                    //     error.title,
                    //     error.message,
                    //     [
                    //         {
                    //             text: 'OK'
                    //         }
                    //     ],
                    //     {
                    //         cancelable: false
                    //     }
                    // );
                    return successCallback(false);
                }

                return successCallback(true);

            })
        }

    }

    loadStripeCustomer() {
        this.props.getCustomerAction().then(() => {
            const {error} = this.props.stripe;

            if (error) {
                // Alert.alert(
                //     error.title,
                //     error.message,
                //     [
                //         {
                //             text: 'OK'
                //         }
                //     ],
                //     {
                //         cancelable: false
                //     }
                // );
                return;
            }
        })
    }
}


const mapStateToProps = state => {
    console.log("PRODUCTS")
    console.log(state.products)
    return {
        stripe: state.stripe,
        user: state.user,
        // profilePhoto: state.user.profilePhoto,
        // userNotifications: state.user.notifications,
        // benefitPlans: state.user.benefitPlans,
        // benefits: state.user.benefits,
        // claimOptions: state.claimOptions,
        // countryCodeOptions: state.appConfig.countryCodes,
        // products: state.products.products,
    }
}

export default connect(mapStateToProps,{
    getCustomerAction, getEphemeralKeyAction, deleteCardAction, setDefaultCardAction, getProfileEphemeralKeyAction
})(ProfileWallet);